import Baobab from 'baobab';
var baobabState = {
    currentUser: {},
    models: {
        datagroups: {},
        importSchemes: [],
        listitems: [],
        templates: [],
        rcitemData: {},
        expressions: {},
        typeaheadfunctions: [],
    },
    route: {
        name: '',
        params: {},
        state: {},
    },
    state: {
        appLanguage: 'en_US',
        globalLoading: 0,
        modelTableChangeHistory: [],
        modelTableChangeHistoryIndexPointer: 0,
        importColumnFilters: {},
        datagroups: {},
        loadingInProgress: false,
        tableSelection: {
            id: -1,
            type: 'flow',
        },
        canUseApp: false,
        lastVisited: {},
        datagroupHistory: {},
        selectedRowPath: null,
        tables: {
            editEnabled: {},
            copyForNextEnabled: {},
        },
        lineItemsPagination: {
            page: 1,
            rows: 10000,
            rcitemId: null,
            clusterId: null, //load this over rcitemid if not null
        },
        widgetsLoading: {},
        signInData: {
            companyName: '',
            strings: {
                callToAction: '',
                email: '',
                password: '',
                rememberMe: '',
                signIn: '',
            },
        },
        tagsWithData: {},
    },
};
var baobabOptions = {
    immutable: false,
};
var baobab = new Baobab(baobabState, baobabOptions);
var cursors = {
    models: baobab.select('models'),
    route: baobab.select('route'),
    state: baobab.select('state'),
};
function clear() {
    cursors.models.release();
    cursors.state.release();
}
export { baobab as root, cursors, clear };
